var render, staticRenderFns
import script from "./el-checkbox-group.vue?vue&type=script&lang=js"
export * from "./el-checkbox-group.vue?vue&type=script&lang=js"
import style0 from "./el-checkbox-group.vue?vue&type=style&index=0&id=158f77ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f77ce",
  null
  
)

export default component.exports